<template>
  <!-- 数字展厅 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.name" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item>
              <el-select v-model="form.type" placeholder="请选择类型">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加数字展厅
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="数字展厅名称" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="type" label="数字展厅类型" show-overflow-tooltip>
            <template slot-scope="scope">{{ handleType(scope.row.type) }}</template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog title="数字展厅" @close="onCancel"
        :close-on-click-modal="false" :visible.sync="dialogVisible" :width="'600px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="name">
            <el-input v-model="addForm.name" :disabled="operation == 'view'" placeholder="请输入数字展厅名称" />
          </el-form-item>

          <el-form-item class="mb-30" prop="type">
            <el-select v-model="addForm.type" :disabled="operation == 'view'" placeholder="请选择数字展厅类型">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="mb-30" prop="pcUrl">
            <el-input v-model="addForm.pcUrl" :disabled="operation == 'view'" placeholder="请输入URL" />
          </el-form-item>

          <!-- <el-form-item class="mb-30" prop="ydUrl">
            <el-input v-model="addForm.ydUrl" :disabled="operation == 'view'" placeholder="请输入移动端URL" />
          </el-form-item> -->

          <el-form-item class="mb-30" prop="ztjj">
            <el-input type="textarea" v-model="addForm.ztjj" :disabled="operation == 'view'" placeholder="请输入数字展厅简介" />
          </el-form-item>

          <!-- <el-form-item class="mb-30" prop="sjdz">
            <el-input v-model="addForm.sjdz" :disabled="operation == 'view'" placeholder="请输入实际地址" />
          </el-form-item> -->

          <el-form-item class="avatar-uploader-form" required>
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="image/*" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传数字展厅封面</div>
              </div>
            </el-upload>
            <div class="tip-img">建议图片大小：1600 * 900</div>
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation != 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleAvatarSuccess">
    </cropper-image>
  </div>
</template>

<script>
import CropperImage from "@cmp/cropper";

export default {
  components: {
    CropperImage
  },
  data() {
    return {
      form: {
        name: '',
      },
      typeList: [{
        value: '1',
        label: '基本陈列'
      }, {
        value: '2',
        label: '临时展览'
      }],
      operation: 'add',
      addForm: {},
      rules: {
        name: [{ required: true, message: '数字展厅名称不能为空', trigger: 'blur' }],
        szztfm: [{ required: true, message: '数字展厅封面不能为空', trigger: 'change' }],
      },
      configData: {
        tableName: 'collect'
      },
      imgUrl: "",
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getDigitalExhibitionList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    handleType(type) {
      let arr = this.typeList.filter(item => {
        return item.value == type
      })
      if (arr && arr.length > 0) {
        return arr[0].label
      }

      return null
    },

    // 重置查询
    resetForm() {
      this.form = {
        name: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },


    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getDigitalExhibitionDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.szztfm) {
              this.imgUrl = res.result.szztfm
            }

          }
        }
      })
    },

    // 新增
    handleAdd() {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.szztfm) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.szztfm}`
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delDigitalExhibition({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return
      }

      if (fileType === '.jpg' || fileType === '.png' || fileType === '.jpeg' || fileType === '.bmp' || fileType === '.gif') {

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    //封面设置
    uploadPicture() {
      if (this.operation == "view") {
        return
      }
      let option = {
        cropWidth: "345", cropHeight: "194", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.szztfm = res.result.attId
        if (this.addForm.szztfm) {
          this.$nextTick(() => {
            this.$refs.form.clearValidate('szztfm');
          })
        }
      } else {
        this.$message.error(res.message)
      }
    },

    onSubmit() {
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "addDigitalExhibition"
          if (this.addForm.id) {
            url = "updateDigitalExhibition"
          }
          this.$api.applet[url](this.addForm).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '数字展厅修改成功' : '新增数字展厅成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.$refs["form"].clearValidate()
    },

    guide(obj) {
      this.$router.push({
        path: '/applet-management/guide-management',
        query: { guideId: obj.id }
      })
    },
  },
  created() {
    this.getData()

    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .avatar {
          width: 100%;
          height: 120px;
          object-fit: contain;
        }

        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
      .tip-img {
        left: 0;
      }
    }
  }
}
</style>